import { WithClassname } from '../../../../types';
import { Server } from '../../../../types/order';
import { ClockCircleOutlined, UserOutlined } from '@ant-design/icons';
import ClickToCopy from '../../../helpers/ClickToCopy';
import OrderPaymentBreakdown from '../../../payment/OrderPaymentBreakdown';
import React from 'react';
import StorePreview from './StorePreview';
import OrderItemsList from '../../../basket/OrderItemsList';
import { Alert } from 'antd';
import useHelpers from '../../../../hooks/utility/useHelpers';
import OrderMethodIcon from '../../../../assets/icons/OrderMethodIcon';
import classnames from 'classnames';
import { DeliveryProvider, OrderMethod } from '../../../../types/constants';

type Props = {
  data: Server.OrderData;
} & WithClassname;

export default function OrderDraftDetails({ data, className }: Props) {
  const { formatDateTime } = useHelpers();

  return (
    <div className={className}>
      <h1 className="mt-sm">Order ID: {data.id}</h1>
      <div className="mt-sm">
        <StorePreview id={data.company.uuid} data={data.company} />
        <h6 className="mt-sm">
          <UserOutlined className="mr-xs text-md" />
          {`${data.customer_first_name ?? ''} ${data.customer_last_name ?? ''}`.trim()}
          {' / '}
          <ClickToCopy>{data.customer_phone_number}</ClickToCopy>
        </h6>
        <h6 className="mt-sm">
          <OrderMethodIcon
            orderMethod={data.method}
            deliveryProvider={data.delivery_provider}
            className={classnames('mr-xs text-md', {
              '!text-lg':
                data.method === OrderMethod.Delivery &&
                data.delivery_provider !== DeliveryProvider.Standalone,
            })}
          />
          <span className="uppercase">{data.method}</span>
        </h6>
        <h6 className="mt-sm">
          <ClockCircleOutlined className="mr-xs text-md" />
          <span className="uppercase">Placed on: {formatDateTime(data.created_at)}</span>
        </h6>
      </div>

      <div className="grid grid-cols-4 gap-xl relative">
        <OrderItemsList data={data.line_items} className="col-span-3 mt-md" />
        <div className="bg-gray-50 sticky top-sm h-fit p-sm rounded-md max-h-[calc(100vh-24px)] overflow-y-auto">
          <h6 className="uppercase">Payment details</h6>
          <OrderPaymentBreakdown data={data} className="mt-sm">
            <Alert
              showIcon
              type="warning"
              message="Payment pending"
              description="We are awaiting payment by the customer for this order"
              className="mt-sm"
            />
          </OrderPaymentBreakdown>
        </div>
      </div>
    </div>
  );
}
